import { Heading, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import { headingC, imageC, itemC, sectionWrapper, wrapperC } from './Cards4IconBg.module.scss';

const Item = ({ heading, desc, img, color }) => {
  return (
    <div className={itemC} style={{ backgroundColor: color }}>
      <Heading Tag="h3" bold size="SM" marginBottom="Xxs" style={{ position: 'relative', zIndex: 2 }}>
        {heading}
      </Heading>
      <P style={{ position: 'relative', zIndex: 2 }}>{desc}</P>
      <img src={img.publicURL} className={imageC} />
    </div>
  )
};
Item.propTypes = {
  heading: PropTypes.string.isRequired,
  desc: PropTypes.string,
  img: PropTypes.object,
  color: PropTypes.string
};

const Cards4IconBg = ({ data, padding, theme, wrapper }) => (
  <Section padding={padding} theme={theme}>
    <Wrapper size={wrapper} className={sectionWrapper}>
      <div className={wrapperC}>
        {data.list.map((props, i) => (
          <Item {...props} key={i} />
        ))}
      </div>
      <div className={headingC}>
        <Heading Tag="h2" bold size="M" marginBottom="Xxs">
          {data.heading}
        </Heading>
        <P>{data.desc}</P>
      </div>
    </Wrapper>
  </Section>
);
Cards4IconBg.propTypes = {
  data: PropTypes.object.isRequired,
  padding: PropTypes.string,
  theme: PropTypes.string,
  wrapper: PropTypes.string,
};
Cards4IconBg.defaultProps = {
  data: {},
  padding: 'L',
  theme: null,
  wrapper: 'M'
}

export default Cards4IconBg;
